<template>
  <ul
    class="burger-nav-tree"
    :style="{
      zIndex: level,
      minHeight: parentMinHeight ? `${parentMinHeight}px` : minHeight
    }"
  >
    <li
      v-if="headline"
      class="burger-nav-tree__item burger-nav-tree__item--headline"
      @click="goBack"
      role="button"
      tabindex="0"
      :aria-label="$t('global.button.back.aria.label')"
      @keydown="handleKeyDown"
    >
      {{ headline }}
    </li>
    <li
      v-if="allCategoriesLink && level > 1"
      class="burger-nav-tree__item burger-nav-tree__item--category-special"
    >
      <a
        :href="allCategoriesLink.url"
        class="burger-nav-tree__link"
      >
        {{ allCategoriesLink.name }}
      </a>
    </li>
    <template v-if="isActive">
      <li
        class="burger-nav-tree__item"
        :class="{
          'burger-nav-tree__item--subcategory_first': index === 0,
          'burger-nav-tree__item--subcategory_last': index === categories.length - 1,
        }"
        v-for="(category, index) in categories"
        :key="`${level}-${index}`"
        ref="subcategory"
      >
        <template v-if="category.subcategories && category.subcategories.length">
          <span
            class="burger-nav-tree__link burger-nav-tree__link--arrow"
            @click="openSubcategory(index)"
            tabindex="0"
            role="button"
            :aria-label="$t('global.open.category.aria.label',[category.name])"
            @keydown="handleKeyDown"
          >
            {{ category.name }}
          </span>
          <burger-nav-tree
            class="burger-nav-tree__subcategories"
            :class="{
              'burger-nav-tree__subcategories--active': activeSubcategory === index
            }"
            :is-active="activeSubcategory === index"
            :headline="category.name"
            :categories="category.subcategories"
            :level="level + 1"
            :all-categories-link="{
              url: category.url,
              name: $t('global.allArticles.link')
            }"
            :parent-min-height="rootMinHeight ? rootMinHeight : parentMinHeight"
            @goback="goBackHandler"
            @heightupdate="heightUpdateHandler"
          />
        </template>
        <template v-else>
          <a
            :href="category.url"
            class="burger-nav-tree__link"
          >
            {{ category.name }}
          </a>
        </template>
      </li>
    </template>
  </ul>
</template>

<script>
  import pigeon from '../../utilities/js/pigeon/pigeon.js';

  export default {
    props: {
      headline: String,
      categories: {
        type: Array,
        default() {
          return [];
        }
      },
      level: {
        type: Number,
        default: 0
      },
      allCategoriesLink: Object,
      isActive: {
        type: Boolean,
        default: true
      },
      parentMinHeight: Number
    },
    data() {
      return {
        activeSubcategory: -1,
        minHeight: '',
        rootMinHeight: null
      };
    },
    emits: ['heightupdate', 'goback', 'heightupdate',],
    methods: {
      openSubcategory(index) {
        pigeon.publish('burgernavtree:levelchange');
        this.activeSubcategory = index;

        this.$nextTick(() => {
          let minHeight = this.$refs.subcategory[index].querySelector('.burger-nav-tree__subcategories').offsetHeight;

          if (this.level === 0) {
            this.minHeight = `${this.calculateMinHeight(minHeight)}px`;
          } else {
            this.$emit('heightupdate', { minHeight: minHeight });
          }
        })
      },
      goBack() {
        pigeon.publish('burgernavtree:levelchange');
        this.$emit('goback');
      },
      goBackHandler() {
        this.activeSubcategory = -1;

        if (this.level === 0) {
          this.minHeight = '';
        } else {
          this.$emit('heightupdate', { minHeight: this.$el.offsetHeight });
        }
      },
      heightUpdateHandler(data) {
        if (this.level === 0) {
          this.minHeight = `${this.calculateMinHeight(data.minHeight)}px`;
        } else {
          this.$emit('heightupdate', data);
        }
      },
      calculateMinHeight(minHeight) {
        if (!this.rootMinHeight) {
          this.rootMinHeight = this.$el.offsetHeight;
        }

        return minHeight >= this.rootMinHeight ? minHeight : this.rootMinHeight;
      },
      handleKeyDown(event) {
        if (event.key === 'Enter' || event.code === 'Space') {
          event.preventDefault();
          event.target.click();
        }
      }
    }
  };

</script>
